import React from 'react';
import { Calculator, FileText, Phone, Settings } from 'lucide-react';
export function Toolbox() {
  const tools = [{
    id: 'calculator',
    name: 'Calculatrice',
    icon: <Calculator size={32} data-id="element-183" />,
    color: 'bg-blue-500'
  }, {
    id: 'templates',
    name: 'Modèles',
    icon: <FileText size={32} data-id="element-184" />,
    color: 'bg-green-500'
  }, {
    id: 'contacts',
    name: 'Contacts urgence',
    icon: <Phone size={32} data-id="element-185" />,
    color: 'bg-red-500'
  }, {
    id: 'settings',
    name: 'Paramètres',
    icon: <Settings size={32} data-id="element-186" />,
    color: 'bg-gray-500'
  }];
  return <div className="p-4 space-y-4" data-id="element-187">
      <h2 className="text-xl font-semibold text-gray-900" data-id="element-188">Boîte à outils</h2>
      <div className="grid grid-cols-2 gap-4" data-id="element-189">
        {tools.map(tool => <button key={tool.id} className="bg-white rounded-lg border border-gray-200 p-6 flex flex-col items-center justify-center space-y-3 hover:shadow-md transition-shadow" data-id="element-190">
            <div className={`${tool.color} text-white p-4 rounded-full`} data-id="element-191">
              {tool.icon}
            </div>
            <span className="font-medium text-gray-900 text-center" data-id="element-192">
              {tool.name}
            </span>
          </button>)}
      </div>
    </div>;
}